export class RoutePaths {
  public static Update = 'update';
  public static Links = 'links';
  public static Resume = 'resume';
  public static PointDrawing = "pointdrawing"
  public static PrintLayout = 'printlayout';
}
